// extracted by mini-css-extract-plugin
export default {"text":"styles__text--tHoEk","header-1":"styles__header-1--VYfmy","header-2":"styles__header-2--f96J5","header-3":"styles__header-3--fEXY4","compact":"styles__compact--IWJCV"};